import { Injectable } from '@angular/core';
import { RestService } from '../_rest.service';

@Injectable({
  providedIn: 'root'
})
export class ForumEvenementService extends RestService{

  init(){
    this.endpoint = 'evenements';
    this.modelname = 'evenement';
    }
}
